// this interface is meant to retrieve venue specific information
// first looking at the state and then the localstorage
import { fetchStorageForUser } from 'helpers/local-storage';

export const getFirstLinkedVenue = user => {
  // This venuesList arr is returned directly from the server
  const hasVenues = user && user.venuesList && user.venuesList.length > 0;
  return hasVenues ? user.venuesList[0] : {};
};

export const getVenuesList = user => {
  const { venuesList = [] } = user;
  return venuesList;
};

export const getActiveVenueId = (user, routeParams = {}, routeQuery = {}) => {
  if (!user) return null;

  if (routeParams.venueId) {
    return routeParams.venueId;
  }

  const queryVenueId = Number(routeQuery.venueId);
  if (queryVenueId && user.venuesList.some(({ venueId }) => venueId === queryVenueId)) {
    return queryVenueId;
  }

  const userStorage = fetchStorageForUser(user.userId) || {};
  const storageVenueId = Number(userStorage.selectedVenueId);
  if (storageVenueId && user.venuesList.some(({ venueId }) => venueId === storageVenueId)) {
    return storageVenueId;
  }

  return getFirstLinkedVenue(user).venueId || null;
};

export const getActiveVenue = (user, activeVenueId) => {
  const hasVenues = user && user.venuesList && user.venuesList.length > 0;
  return hasVenues ? user.venuesList.find(v => v.venueId === activeVenueId) : {};
};

export const userHasAccessToVenue = (user, venueId) => {
  const id = parseInt(venueId, 10);
  const venues = getVenuesList(user);
  return venues.some(venue => venue.venueId === id);
};

export const getUserVenue = (user, venueId) => {
  if (!venueId) {
    return getFirstLinkedVenue(user);
  }

  const id = parseInt(venueId, 10);
  const venues = getVenuesList(user);
  return venues.find(venue => venue.venueId === id);
};
